import { useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";

const useVerifyBankAccount = (token) => {
    const [isAccountVerified, setIsAccountVerified] = useState(false);
    const [verifiedAccountName, setVerifiedAccountName] = useState("");
    const [verifyErrorMsg, setVerifyErrorMsg] = useState("");

    const verifyBankFunction = async ({ accountNumber, ifsc }) => {
        const response = await axios.get(
            `${Config.apiUrl}/cashfree/payout/verify/account`,
            {
                params: {
                    accountNumber,
                    ifsc,
                },
                headers: {
                    authorization: `Bearer ${token}`,
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );

        return response.data;
    };

    const {
        mutate: verifyBankAccount,
        isLoading: verifyAccountLoading,
        reset,
    } = useMutation({
        mutationFn: verifyBankFunction,
        onSuccess: (res) => {
            if (res.isSuccess) {
                setVerifiedAccountName(res?.data?.accountHolderName);
                setIsAccountVerified(res?.data?.isVerified);
                setVerifyErrorMsg("");
            }
        },
        onError: (error) => {
            setVerifyErrorMsg(
                error?.response?.data?.msg ||
                "Account verification failed. Please check the account number and IFSC code."
            );

            setVerifiedAccountName("");
            setIsAccountVerified(false);
        },
    });

    const clearVerification = () => {
        reset();
        setVerifiedAccountName("");
        setVerifyErrorMsg("");
        setIsAccountVerified(false);
    };

    return {
        verifyBankAccount,
        verifyAccountLoading,

        isAccountVerified,
        verifiedAccountName,
        verifyErrorMsg,

        setVerifiedAccountName,
        setVerifyErrorMsg,
        setIsAccountVerified,

        clearVerification,
    };
};

export default useVerifyBankAccount;